import React from 'react';
import { LayoutChangeEvent, View } from 'react-native';

// @ts-ignore
import VimeoVideo from './vimeo-video';
import type { VimeoPlayerProps } from './vimeo-video-props';
import { height } from '../../style-utils';

export const VimeoPlayer = ({
  src,
  ratio,
  autoplay,
  autopause,
  controls = true,
  loop,
  maxHeight,
  containerStyle,
  ...props
}: VimeoPlayerProps) => {
  const [size, setSize] = React.useState<{ width: number; height: number }>();

  if (!src) {
    return null;
  }
  let _src = src;
  _src += src.includes('?') ? '' : '?';
  _src += `&autoplay=${autoplay ? 1 : 0}`;
  _src += `&autopause=${autopause ? 1 : 0}`;
  _src += `&loop=${loop ? 1 : 0}`;
  _src += `&controls=${controls ? 1 : 0}`;

  const onContainerLayout = (e: LayoutChangeEvent) => {
    // Calculate the height based on the width and the ratio
    const height = e.nativeEvent.layout.width / ratio;

    // If a maximum height is defined and the calculated height is greater than this maximum
    if (maxHeight && height > maxHeight) {
      // Set the size with the maximum height and the corresponding width based on the ratio
      setSize({
        width: maxHeight * ratio,
        height: maxHeight,
      });
    } else {
      // If no maximum height is defined or the calculated height is less than the maximum, set the size with the calculated height and the original width
      setSize({
        width: e.nativeEvent.layout.width,
        height,
      });
    }
  };

  return (
    <View
      onLayout={onContainerLayout}
      style={[height(size?.height), containerStyle]}
    >
      {!!size && (
        <VimeoVideo
          src={_src}
          width={size?.width}
          height={size?.height}
          {...props}
        />
      )}
    </View>
  );
};
